// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"270":"ad12e0b6","466":"84cf102a","592":"014976c1","661":"a127153a","859":"0c2f5fa8"}[chunkId] + ".chunk.css";
};